/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AtecoCodeBaseResponse } from '../models/ateco-code-base-response';
import { AtecoCodeInputModel } from '../models/ateco-code-input-model';
import { AtecoCodeModel } from '../models/ateco-code-model';
import { deleteApiAtecocodeV1Id$Json } from '../fn/ateco-code/delete-api-atecocode-v-1-id-json';
import { DeleteApiAtecocodeV1Id$Json$Params } from '../fn/ateco-code/delete-api-atecocode-v-1-id-json';
import { deleteApiAtecocodeV1Id$Plain } from '../fn/ateco-code/delete-api-atecocode-v-1-id-plain';
import { DeleteApiAtecocodeV1Id$Plain$Params } from '../fn/ateco-code/delete-api-atecocode-v-1-id-plain';
import { getApiAtecocodeV1Id$Json } from '../fn/ateco-code/get-api-atecocode-v-1-id-json';
import { GetApiAtecocodeV1Id$Json$Params } from '../fn/ateco-code/get-api-atecocode-v-1-id-json';
import { getApiAtecocodeV1Id$Plain } from '../fn/ateco-code/get-api-atecocode-v-1-id-plain';
import { GetApiAtecocodeV1Id$Plain$Params } from '../fn/ateco-code/get-api-atecocode-v-1-id-plain';
import { postApiAtecocodeImport$Json } from '../fn/ateco-code/post-api-atecocode-import-json';
import { PostApiAtecocodeImport$Json$Params } from '../fn/ateco-code/post-api-atecocode-import-json';
import { postApiAtecocodeImport$Plain } from '../fn/ateco-code/post-api-atecocode-import-plain';
import { PostApiAtecocodeImport$Plain$Params } from '../fn/ateco-code/post-api-atecocode-import-plain';
import { postApiAtecocodeV1$Json } from '../fn/ateco-code/post-api-atecocode-v-1-json';
import { PostApiAtecocodeV1$Json$Params } from '../fn/ateco-code/post-api-atecocode-v-1-json';
import { postApiAtecocodeV1$Plain } from '../fn/ateco-code/post-api-atecocode-v-1-plain';
import { PostApiAtecocodeV1$Plain$Params } from '../fn/ateco-code/post-api-atecocode-v-1-plain';
import { postApiAtecocodeV1Create$Json } from '../fn/ateco-code/post-api-atecocode-v-1-create-json';
import { PostApiAtecocodeV1Create$Json$Params } from '../fn/ateco-code/post-api-atecocode-v-1-create-json';
import { postApiAtecocodeV1Create$Plain } from '../fn/ateco-code/post-api-atecocode-v-1-create-plain';
import { PostApiAtecocodeV1Create$Plain$Params } from '../fn/ateco-code/post-api-atecocode-v-1-create-plain';
import { putApiAtecocodeV1Id$Json } from '../fn/ateco-code/put-api-atecocode-v-1-id-json';
import { PutApiAtecocodeV1Id$Json$Params } from '../fn/ateco-code/put-api-atecocode-v-1-id-json';
import { putApiAtecocodeV1Id$Plain } from '../fn/ateco-code/put-api-atecocode-v-1-id-plain';
import { PutApiAtecocodeV1Id$Plain$Params } from '../fn/ateco-code/put-api-atecocode-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class AtecoCodeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiAtecocodeV1()` */
  static readonly PostApiAtecocodeV1Path = '/private/v1/ateco-codes';

  /**
   * Retrieves the list of all available ATECO code entities.
   *
   * Retrieves the list of all available ATECO code entities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAtecocodeV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1$Plain$Response(params?: PostApiAtecocodeV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeBaseResponse>> {
    return postApiAtecocodeV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available ATECO code entities.
   *
   * Retrieves the list of all available ATECO code entities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAtecocodeV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1$Plain(params?: PostApiAtecocodeV1$Plain$Params, context?: HttpContext): Observable<AtecoCodeBaseResponse> {
    return this.postApiAtecocodeV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeBaseResponse>): AtecoCodeBaseResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all available ATECO code entities.
   *
   * Retrieves the list of all available ATECO code entities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAtecocodeV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1$Json$Response(params?: PostApiAtecocodeV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeBaseResponse>> {
    return postApiAtecocodeV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available ATECO code entities.
   *
   * Retrieves the list of all available ATECO code entities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAtecocodeV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1$Json(params?: PostApiAtecocodeV1$Json$Params, context?: HttpContext): Observable<AtecoCodeBaseResponse> {
    return this.postApiAtecocodeV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeBaseResponse>): AtecoCodeBaseResponse => r.body)
    );
  }

  /** Path part for operation `getApiAtecocodeV1Id()` */
  static readonly GetApiAtecocodeV1IdPath = '/private/v1/ateco-codes/{id}';

  /**
   * Retrieves a ATECO Code by ID.
   *
   * Retrieves a ATECO Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAtecocodeV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAtecocodeV1Id$Plain$Response(params: GetApiAtecocodeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeModel>> {
    return getApiAtecocodeV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a ATECO Code by ID.
   *
   * Retrieves a ATECO Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAtecocodeV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAtecocodeV1Id$Plain(params: GetApiAtecocodeV1Id$Plain$Params, context?: HttpContext): Observable<AtecoCodeModel> {
    return this.getApiAtecocodeV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeModel>): AtecoCodeModel => r.body)
    );
  }

  /**
   * Retrieves a ATECO Code by ID.
   *
   * Retrieves a ATECO Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAtecocodeV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAtecocodeV1Id$Json$Response(params: GetApiAtecocodeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeModel>> {
    return getApiAtecocodeV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a ATECO Code by ID.
   *
   * Retrieves a ATECO Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAtecocodeV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAtecocodeV1Id$Json(params: GetApiAtecocodeV1Id$Json$Params, context?: HttpContext): Observable<AtecoCodeModel> {
    return this.getApiAtecocodeV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeModel>): AtecoCodeModel => r.body)
    );
  }

  /** Path part for operation `putApiAtecocodeV1Id()` */
  static readonly PutApiAtecocodeV1IdPath = '/private/v1/ateco-codes/{id}';

  /**
   * Updates an existing ATECO Code by ID.
   *
   * Updates an existing ATECO Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiAtecocodeV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAtecocodeV1Id$Plain$Response(params: PutApiAtecocodeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AtecoCodeModel>>> {
    return putApiAtecocodeV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing ATECO Code by ID.
   *
   * Updates an existing ATECO Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiAtecocodeV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAtecocodeV1Id$Plain(params: PutApiAtecocodeV1Id$Plain$Params, context?: HttpContext): Observable<Array<AtecoCodeModel>> {
    return this.putApiAtecocodeV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AtecoCodeModel>>): Array<AtecoCodeModel> => r.body)
    );
  }

  /**
   * Updates an existing ATECO Code by ID.
   *
   * Updates an existing ATECO Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiAtecocodeV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAtecocodeV1Id$Json$Response(params: PutApiAtecocodeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AtecoCodeModel>>> {
    return putApiAtecocodeV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing ATECO Code by ID.
   *
   * Updates an existing ATECO Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiAtecocodeV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiAtecocodeV1Id$Json(params: PutApiAtecocodeV1Id$Json$Params, context?: HttpContext): Observable<Array<AtecoCodeModel>> {
    return this.putApiAtecocodeV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AtecoCodeModel>>): Array<AtecoCodeModel> => r.body)
    );
  }

  /** Path part for operation `deleteApiAtecocodeV1Id()` */
  static readonly DeleteApiAtecocodeV1IdPath = '/private/v1/ateco-codes/{id}';

  /**
   * Deletes an ATECO Code by ID.
   *
   * Deletes an ATECO Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiAtecocodeV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAtecocodeV1Id$Plain$Response(params: DeleteApiAtecocodeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeModel>> {
    return deleteApiAtecocodeV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an ATECO Code by ID.
   *
   * Deletes an ATECO Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiAtecocodeV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAtecocodeV1Id$Plain(params: DeleteApiAtecocodeV1Id$Plain$Params, context?: HttpContext): Observable<AtecoCodeModel> {
    return this.deleteApiAtecocodeV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeModel>): AtecoCodeModel => r.body)
    );
  }

  /**
   * Deletes an ATECO Code by ID.
   *
   * Deletes an ATECO Code by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiAtecocodeV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAtecocodeV1Id$Json$Response(params: DeleteApiAtecocodeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeModel>> {
    return deleteApiAtecocodeV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an ATECO Code by ID.
   *
   * Deletes an ATECO Code by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiAtecocodeV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAtecocodeV1Id$Json(params: DeleteApiAtecocodeV1Id$Json$Params, context?: HttpContext): Observable<AtecoCodeModel> {
    return this.deleteApiAtecocodeV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeModel>): AtecoCodeModel => r.body)
    );
  }

  /** Path part for operation `postApiAtecocodeV1Create()` */
  static readonly PostApiAtecocodeV1CreatePath = '/private/v1/ateco-codes/create';

  /**
   * Creates a new ATECO Code.
   *
   * Creates a new ATECO Code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAtecocodeV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1Create$Plain$Response(params?: PostApiAtecocodeV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeInputModel>> {
    return postApiAtecocodeV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new ATECO Code.
   *
   * Creates a new ATECO Code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAtecocodeV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1Create$Plain(params?: PostApiAtecocodeV1Create$Plain$Params, context?: HttpContext): Observable<AtecoCodeInputModel> {
    return this.postApiAtecocodeV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeInputModel>): AtecoCodeInputModel => r.body)
    );
  }

  /**
   * Creates a new ATECO Code.
   *
   * Creates a new ATECO Code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAtecocodeV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1Create$Json$Response(params?: PostApiAtecocodeV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AtecoCodeInputModel>> {
    return postApiAtecocodeV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new ATECO Code.
   *
   * Creates a new ATECO Code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAtecocodeV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeV1Create$Json(params?: PostApiAtecocodeV1Create$Json$Params, context?: HttpContext): Observable<AtecoCodeInputModel> {
    return this.postApiAtecocodeV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtecoCodeInputModel>): AtecoCodeInputModel => r.body)
    );
  }

  /** Path part for operation `postApiAtecocodeImport()` */
  static readonly PostApiAtecocodeImportPath = '/private/v1/ateco-codes/import';

  /**
   * Imports ATECO codes from a file in blob storage.
   *
   * Imports ATECO codes from a file in blob storage.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAtecocodeImport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeImport$Plain$Response(params?: PostApiAtecocodeImport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return postApiAtecocodeImport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Imports ATECO codes from a file in blob storage.
   *
   * Imports ATECO codes from a file in blob storage.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAtecocodeImport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeImport$Plain(params?: PostApiAtecocodeImport$Plain$Params, context?: HttpContext): Observable<string> {
    return this.postApiAtecocodeImport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Imports ATECO codes from a file in blob storage.
   *
   * Imports ATECO codes from a file in blob storage.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAtecocodeImport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeImport$Json$Response(params?: PostApiAtecocodeImport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return postApiAtecocodeImport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Imports ATECO codes from a file in blob storage.
   *
   * Imports ATECO codes from a file in blob storage.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAtecocodeImport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAtecocodeImport$Json(params?: PostApiAtecocodeImport$Json$Params, context?: HttpContext): Observable<string> {
    return this.postApiAtecocodeImport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
